const REPORTS = 'reports'
const ACCOUNTING = 'accounting'
const APPRAISERS = 'appraisers'
const CLIENTS = 'clients'
const SETTINGS = 'settings'
export const REGISTER = 'register' // TODO: Remove once new sign up flow is complete
export const REGISTER_V2 = 'register-v2'

export const DEFAULT_ROUTE = REPORTS

export const APPRAISER_ROUTES = [REPORTS, SETTINGS]

export const MANAGER_ROUTES = [REPORTS, ACCOUNTING, APPRAISERS, CLIENTS, SETTINGS]

export const CREATE_ACCOUNT = '/signup/create-account'
export const INFO_STEP = '/signup/info'
export const LOGIN = '/login'
export const LOGOUT = '/logout'
export const SIGNUP = '/signup'
export const ACCOUNT_SETUP = '/signup/account-setup'
export const SIGNUP_SUCCESS = '/signup/success'
